import React, { useState } from 'react';

import Footer from '../components/Footer';
import Navbar from '../components/Navbar';


import image01 from '../assets/CardsImages/card-8-img/img-106.jpg'
import image02 from '../assets/CardsImages/card-8-img/img-107.jpg'
import image03 from '../assets/CardsImages/card-8-img/img-108.jpg'
import image04 from '../assets/CardsImages/card-8-img/img-109.jpg'
import image05 from '../assets/CardsImages/card-8-img/img-110.jpg'
import image06 from '../assets/CardsImages/card-8-img/img-111.jpg'
import image07 from '../assets/CardsImages/card-8-img/img-112.jpg'
import image08 from '../assets/CardsImages/card-8-img/img-110.jpg'
import image09 from '../assets/CardsImages/card-8-img/img-114.jpg'
import image10 from '../assets/CardsImages/card-8-img/img-115.jpg'
import image11 from '../assets/CardsImages/card-8-img/img-116.jpg'
import image12 from '../assets/CardsImages/card-8-img/img-117.jpg'
import image13 from '../assets/CardsImages/card-8-img/img-118.jpg'
import image14 from '../assets/CardsImages/card-8-img/img-119.jpg'
import image15 from '../assets/CardsImages/card-8-img/img-120.jpg'
import image16 from '../assets/CardsImages/card-8-img/img-121.jpg'

const Card08 = () => {


    
        const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image
    
        const images = [
            image01,
            image02,
            image03,
            image04,
            image05,
            image06,
            image07,
            image08,
            image09,
            image10,
            image11,
            image12,
            image13,
            image14,
            image15,
            image16
    
    
            // Add the rest of the images here...
        ];
    
        const handleImageClick = (image) => {
            setSelectedImage(image); // Set the selected image
        };
    
        const handleClose = () => {
            setSelectedImage(null); // Clear the selected image
        };
    
    
    return (

        <div>
            {/* <Navbar /> */}
            <div className="container mx-auto px-6 py-12 mt-8">
                <h1 className="text-3xl font-bold text-center text-purple-900 mb-8">Green Field Project</h1>
                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">
                    <h2 className="text-2xl font-semibold mb-4">Green Field Project Job</h2>
                    <p className="mb-4">
                    A greenfield project refers to a project that involves the construction, development, or establishment of a new facility, venture, or project from the ground up in an area or on a site that is entirely new, undeveloped, and free of any existing infrastructure or constraints. Greenfield projects are typically contrasted with "brownfield projects," which involve redeveloping or repurposing existing facilities or sites that may have previously been used for other purposes.
                    </p>
                </div>

                <div className="container mx-auto px-4 py-8 my-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">Key characteristics of a greenfield project include:</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li><span className='text-purple-800 font-bold'>New Site or Location:</span> Greenfield projects are typically set up in entirely new locations where there is no existing infrastructure, facilities, or development. This often involves acquiring and preparing a vacant piece of land for the project.</li>
                                    <li><span className='text-purple-800 font-bold'>Starting from Scratch:</span> Greenfield projects begin with a clean slate, and the project team has the flexibility to design, plan, and build the new facility or venture according to specific requirements and objectives.</li>
                                    <li><span className='text-purple-800 font-bold'>No Legacy Systems:</span> There are no legacy systems, equipment, or structures to deal with, which can be advantageous in terms of technology adoption and design choices.</li>
                                    <li><span className='text-purple-800 font-bold'>Customization:</span> Greenfield projects offer the opportunity to customize and optimize processes, layouts, and technologies to meet the project's specific needs.</li>
                                    <li><span className='text-purple-800 font-bold'>Higher Initial Investment:</span> Developing a greenfield project often requires a significant initial capital investment for land acquisition, construction, infrastructure development, and equipment purchase.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Examples of greenfield projects can vary widely and may include:</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    
                                    <li><span className='text-purple-800 font-bold'>New manufacturing plants:</span> Building a new manufacturing facility to produce products or goods from scratch, often in a location where the company previously had no presence.</li>
                                    <li><span className='text-purple-800 font-bold'>Infrastructure development:</span> Developing new transportation infrastructure like airports, ports, roads, or railways in previously undeveloped areas.</li>
                                    <li><span className='text-purple-800 font-bold'>Residential and commercial real estate:</span> Constructing new housing developments, shopping centers, or office complexes on vacant land.</li>
                                    <li><span className='text-purple-800 font-bold'>Power plants:</span> Building new power generation facilities, such as solar farms, wind farms, or traditional power plants, in locations with available resources and favorable conditions.</li>
                                    <li><span className='text-purple-800 font-bold'>Agricultural ventures:</span> Establishing new farms, plantations, or agribusiness operations in rural areas.</li>
                                    <li><span className='text-purple-800 font-bold'>Technology startups:</span> Launching a new technology-based business or software application from the ground up.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>


                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">

                    <p className="mb-4">
                    Greenfield projects are often seen as opportunities for innovation and growth, as they allow organizations to create something entirely new without the constraints of existing structures or systems. However, they also come with challenges, including the need for comprehensive planning, substantial investment, and the establishment of necessary infrastructure and logistics to support the project's success. Additionally, environmental and regulatory considerations may play a significant role in the development of greenfield projects, especially in environmentally sensitive areas.


                    </p>
                </div>


                {/* All Work Section */}
                <div className="my-12 text-center">
                    <h2 className="text-2xl font-semibold text-purple-900 mb-4">All Work</h2>
                    <p className="text-lg text-gray-700 mb-4">We provide high standard work for your Company solutions</p>
                </div>

                {/* Images Section */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>


                    {/* Modal to show selected image */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                            <div className="relative">
                                <img
                                    src={selectedImage}
                                    alt="Selected"
                                    className="max-w-full max-h-screen rounded-lg"
                                />
                                <button
                                    onClick={handleClose}
                                    className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                                >
                                    ✖
                                </button>
                            </div>
                        </div>
                    )}
            </div>

            {/* <Footer /> */}
        </div>
    );
};

export default Card08;
